import React from "react";
import { useCurrentUserLocale } from "@linkfluence/core/user/use-cases";
import { useHorizontalPagination } from "@lkf/hooks";
import Panel from "@radarly/components/panels/image-cluster";
import { useVisibleBanner } from "@radarly/core/context/use-cases";
import { useClosePanel } from "@radarly/core/panel/use-cases";
import { tr } from "@radarly/i18n";
import { ImageClusterPanel } from "@radarly/models/panel";
import { Project } from "@radarly/models/project";
import SharedImageCluster from "@radarly/shared/image-cluster";

interface IProps {
  clusters: ImageClusterPanel["clusters"];
  clusterKey: ImageClusterPanel["key"];
  onClose: ImageClusterPanel["onClose"];
  project: Project;
}

const RadarlyImageClusterPanel = ({
  clusters,
  clusterKey,
  onClose,
  project,
}: IProps) => {
  const onClosePanel = useClosePanel();
  const { page, onPageLeft, onPageRight } = useHorizontalPagination(
    clusterKey,
    clusters.length
  );
  const locale = useCurrentUserLocale();

  const onClickClosePanel = () => {
    onClose();
    onClosePanel("image-cluster");
  };

  const banner = useVisibleBanner();
  return (
    <Panel
      onClose={onClickClosePanel}
      onPageLeft={onPageLeft}
      onPageRight={onPageRight}
      canPageLeft={page > 0}
      canPageRight={page < clusters.length - 1}
      paginationLabel={tr(locale, "IMAGE_CLUSTER::PAGINATION_LABEL", {
        index: page + 1,
        size: clusters.length,
      })}
      locale={locale}
      isBelowBanner={!!banner}
    >
      <SharedImageCluster
        key={page}
        cluster={clusters[page]}
        display="grid"
        project={project}
      />
    </Panel>
  );
};

export default RadarlyImageClusterPanel;
